import React from "react";
import AppProvider from "./providers/AppProvider";
import { AppRoutes } from "./routes/AppRoutes";

function FieldManagerApp(props:any) {
    return (
      <AppProvider currentUser={props.currentUser} userOrgs={props.userOrgs} localePreferences={props.localePreferences} refreshAllCredentials={props.refreshAllCredentials}>
          <AppRoutes />
      </AppProvider>
    );
  }

  export { FieldManagerApp };
